export const openmodel = (setOpen, navigate) => {
  navigate("/agreement");
};
export const downloadApp = () => {
  console.log("hello");
};
